export enum Meridian {
  am = 'AM',
  pm = 'PM',
}
